import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getROBServiceRequest(requestData) {
    return axios.post(ENV.carBaseUrl + "/robnet/service_requests/list", requestData, this.requestConfig());
  }
}

export default Service;
